import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadBulkVoidAtom = createMutationAtomFactory(
  'trade.loadBulkVoid',
  (params: { ids: string[] }) => ({
    tradeLoadBulkVoid: {
      __args: {
        input: {
          ids: params.ids,
        },
      },
      successCount: true,
      failedCount: true,
      failedIds: true,
    },
  }),
);
